import React from "react";
import WithConfigurations from "../WithConfigurations";
import WithPreferences from "../WithPreferences";
import { getDisplayName } from "Utils/HOCHelpers";

const WithConfigurationsAndPreferences = hocConfiguration => Component => {
  const {
    configurations = {},
    preferences = {},
    getConfigurationKey,
    getConfigurationKeys,
    ...defaultHocConfiguration
  } = hocConfiguration;

  function SetupConfigurations(props) {
    return <Component {...props} />;
  }

  SetupConfigurations.displayName = `WithConfigurationsAndPreferences(${getDisplayName(
    Component
  )})`;

  return WithConfigurations({
    ...defaultHocConfiguration,
    getConfigurationKey,
    getConfigurationKeys,
    ...configurations,
  })(
    WithPreferences({
      ...defaultHocConfiguration,
      ...preferences,
    })(SetupConfigurations)
  );
};

export default WithConfigurationsAndPreferences;
